import constant from '../constants/constant'
const axios = require('axios')

const makeRequestHeader = () => {
	const access_token = localStorage.getItem('access_token')
	let headers = {}
	if( access_token ) {
		headers['Authorization'] = 'Bearer '+access_token
	}
	return headers
}

const get = async (uri, params, returnPromise = false, rethrowError = false) => {
	const headers = makeRequestHeader()
	try {
		if (returnPromise) {
			return axios.get(constant.BACKEND_DOMAIN+uri, {headers, params})
		}
		const response = await axios.get(constant.BACKEND_DOMAIN+uri, {headers, params})
		return response?.data
	} catch (e) {
		// Ignore intentional cancellations (navigation / unmount) to avoid noisy console errors.
		// Axios v0.x sets __CANCEL__, v1.x uses code === 'ERR_CANCELED'.
		if (e?.__CANCEL__ || e?.code === 'ERR_CANCELED') {
			return
		}
		if (!e.response || e.response.status === 401) {
			console.error('An error occurred:', e);
		}
		if (rethrowError) {
			throw e
		}
	}
}

/**
 * Download file from api
 *
 * Sets responseType to 'blob' to download file
 *
 * @param {string} uri
 * @param {object} params
 *
 * @returns {Promise}
 */
const download = async (uri, params) => {
	const headers = makeRequestHeader()
	const response = await axios.get(constant.BACKEND_DOMAIN+uri, {headers, params, responseType: 'blob'})
	return response?.data
}

const post = async (uri, data, params) => {
	const headers = makeRequestHeader()
	const response = await axios.post(constant.BACKEND_DOMAIN+uri, data, {headers, params})
	return response?.data	
}

const patch = async (uri, data, params) => {
	const headers = makeRequestHeader()
	const response = await axios.patch(constant.BACKEND_DOMAIN+uri, data, {headers, params})
	return response?.data
}

const formPost = async (uri, formData) => {
	const headers = makeRequestHeader()
	headers['Content-Type'] = 'multipart/form-data'
	const response = await axios.post(constant.BACKEND_DOMAIN+uri, formData, {headers})
	return response?.data	
}

const _delete = async (uri, params) => {
	const headers = makeRequestHeader()
	const response = await axios.delete(constant.BACKEND_DOMAIN+uri, {headers, params})
	return response?.data	
}

export default {
	get,
	post,
	patch,
	formPost,
	_delete,
	download,
}